import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'sh-platform-progress-indicator',
  templateUrl: './platform-progress-indicator.component.html',
  styleUrl: './platform-progress-indicator.component.scss',
  standalone: false
})
export class PlatformProgressIndicatorComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
